// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__vazq3","loader":"styles_loader__My8mq","spin":"styles_spin__NNG0B","mask":"styles_mask__RgRqS"};